/* globals Vue */
import { Tabs } from "buefy";
Vue.use(Tabs);
// Componentes específicos de Mex
import SvlpSucursalVirtualComponent from "../../components/sucursal-virtual/SvlpSucursalVirtualComponent.vue";

const sucursalVirtual = new Vue({
  el: "#sv-app",
  components: {
    SvlpSucursalVirtualComponent,
  },
});

window.sucursalVirtual = sucursalVirtual;